import React from 'react'
import { Link } from 'gatsby'

import Logo from '../components/logo'

import '../style/index.scss'

const Index = () => (
  <div className="portal">
    <div className="portal__mt">
      <div className="portal__container">
        <Logo site="mt" />
        <Link
          className="portal__button portal__button--mt"
          to="/mt/general/about-currency/design/"
        >
          Explore Currency
        </Link>
      </div>
    </div>
    <div className="portal__wt">
      <div className="portal__container">
        <Logo site="wt2" />
        <Link
          className="portal__button portal__button--wt"
          to="/wt/general/about-currency/design/"
        >
          Explore Currency
        </Link>
      </div>
    </div>
  </div>
)

export default Index
